import { LogEntry } from "../features/log/logEntry";

const READONLY_API_KEY = 'keyMQt0TCIOOHk5s5',
  DOC = 'appTtOP3SFp8zrdSq',
  PROGRESS_DOC = 'appWrbcOyCluCPN9r',
  PILGRIMAGES_TABLE = 'Pilgrimages',
  STAGES_TABLE = 'Stages',
  CONTENT_TABLE = 'Content',
  CHECKINS_TABLE = 'CheckIns';

export interface Attachment {
  id: string;
  url: string;
  filename: string;
  size: number;
  type: string;
}

/** Pilgrimages tab */
export interface Pilgrimage {
  Year: number;
  Church: string;
  Name: string;
}

export interface PilgrimageRecord {
  id: string;
  fields: Pilgrimage;
  createdTime: Date;
}

export interface AirtablePilgrimageResponse {
  records: PilgrimageRecord[];
}

export const getPilgrimages : () => Promise<AirtablePilgrimageResponse> = async () => {
  const resp = await fetch(`https://api.airtable.com/v0/${DOC}/${PILGRIMAGES_TABLE}?api_key=${READONLY_API_KEY}`),
    { records } = await resp.json();
  return { records };
}

/** Stages tab */
export interface StageData {
  Start: string[];
  distance: number;
  End: string[];
  ID: string;
  Pilgrimage: string[];
  StartLng: number[];
  StartLat: number[];
  StartName: string[];
  EndLng: number[];
  EndLat: number[];
  EndName: string[];
  Order: number;
  image?: Attachment[];
  Directions?: any;
}

export interface StageRecord {
  id: string;
  fields: StageData;
  createdTime: Date;
}

export interface AirtableStagesResponse {
  records: StageRecord[];
}

export const getStages : (pilgrimageId : string) => Promise<AirtableStagesResponse> = async (pilgrimageId : string) => {
  const resp = await fetch(`https://api.airtable.com/v0/${DOC}/${STAGES_TABLE}?api_key=${READONLY_API_KEY}`),
    json : AirtableStagesResponse = await resp.json();
  return {
    records: json.records
      .filter(record => record.fields.Pilgrimage?.includes(pilgrimageId))
      .sort((a, b) => a.fields.Order < b.fields.Order ? -1 : 1)
  }
}

/** CheckIns Tab */
export interface CheckInFields {
  Name: string;
  Date: string;
  Type: string;
  Location: string;
  Calendar: string;
  Pilgrimages: string[];
}

export interface CheckInRecord {
  id: string;
  fields: CheckInFields;
  createdTime: Date;
}

export interface AirtableCheckInsResponse {
  records: CheckInRecord[];
}

export const getCheckIns : (pilgrimageId : string) => Promise<AirtableCheckInsResponse> = async (pilgrimageId : string) => {
  const resp = await fetch(`https://api.airtable.com/v0/${DOC}/${CHECKINS_TABLE}?api_key=${READONLY_API_KEY}`),
    json : AirtableCheckInsResponse = await resp.json();
  return {
    records: json.records
      .filter(record => record.fields.Pilgrimages?.includes(pilgrimageId))
  }
}

/** Content Tab */
export interface ContentFields {
  Type: string;
  ID: string;
  Pilgrimage: string[];
  Unlocked_After: number;
  Title: string;
  Author: string;
  Content: string;
  Scripture: string;
  Attachments: Attachment[];
  YoutubeURL: string;
}

export interface ContentRecord {
  id: string;
  fields: ContentFields;
  createdTime: Date;
}

export interface AirtableContentResponse {
  records: ContentRecord[];
}

export const getContent : (pilgrimageId : string) => Promise<AirtableContentResponse> = async (pilgrimageId : string) => {
  const resp = await fetch(`https://api.airtable.com/v0/${DOC}/${CONTENT_TABLE}?api_key=${READONLY_API_KEY}`),
    json : AirtableContentResponse = await resp.json(),
    records = json.records
      .filter(record => record.fields.Pilgrimage?.includes(pilgrimageId));
  return {
    records
  }
}

/** Append log to progress chart and return a unique ID from Airtable identifying this record*/
export const createLogEntryInDatabase = async (entry : LogEntry, pilgrimageId : string, User : string, homeChurch : string | null) => {
  const fields = {
    pilgrimageId,
    User,
    HomeChurch: homeChurch ?? '',
    Distance: entry.distance,
    Date: entry.date,
    Type: entry.type
  };

  const response = await fetch(`https://api.airtable.com/v0/${PROGRESS_DOC}/Data`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${READONLY_API_KEY}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      records: [{
        fields
      }]
    })
  });
  const data = await response.json();
  return data.records[0].id;
}

export const removeLogEntryFromDatabase : (id : string | undefined) => Promise<void> = async (id : string | undefined) => {
  if(id && id !== 'OFFLINE') {
    await fetch(`https://api.airtable.com/v0/${PROGRESS_DOC}/Data/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${READONLY_API_KEY}`
      }
    });
  }
}